import React from 'react';
import { ResumeSection } from './ResumeSection';

interface Props {
  summary: string;
}

export function ResumeSummary({ summary }: Props) {
  return (
    <ResumeSection title="Professional Summary">
      <p className="resume-paragraph">{summary}</p>
    </ResumeSection>
  );
}
